import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import {errorMessage$, successMessage$} from '../../../utils/subjects';
import api from '../../../services/api';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function DialogCurrencyDelete({handleClose, handleOpen, open, id, callback}) {
  const classes = useStyles();
  const [currencyId] = useState(id);
  const [name, setName] = useState('');
  const [abbreviation, setAbbreviation] = useState('');

  useEffect(() => {
    const loadCurrency = async () => {
      try {
        const response = await api.get(`master/currencies/${currencyId}`);

        setName(response.data.Name);
        setAbbreviation(response.data.Abbreviation);
      } catch (err) {
        errorMessage$.next({open: true, message: 'Error to get currency information'});
      }
    }

    loadCurrency();
  }, [currencyId]);


  async function handleSubmit(e) {
    e.preventDefault();

    try {
      handleClose();
      await api.delete(`master/currencies/${currencyId}`);
      
      successMessage$.next({open: true, message: 'Currency deleted successfully'});
      if (callback) callback();
    } catch (err) {
      errorMessage$.next({open: true, message: 'Error on delete currency'});
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Do you confirm?</DialogTitle>
      <form className={classes.root} onSubmit={handleSubmit}>
        <DialogContent>
          <p>
            Do you would to like to delete "{name}" - {abbreviation}
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button color="primary" type="submit">
            Delete
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}